export default __webpack_public_path__ + "static/media/auth_background.36e9c78b.png";